var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImpersonate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2H20.1818C21.186 2 22 2.89543 22 4V8H20V4H16V2zM3.81818 22H8V20H4V16H2v4C2 21.1046 2.81403 22 3.81818 22zM16 20v2H20.1818C21.186 22 22 21.1046 22 20V16H20v4H16zM8 4V2H3.81818C2.81403 2 2 2.89543 2 4V8H4V4H8z",
    fill: "#006aff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14c0 1 1 3 4 3 3 0 4-2 4-3",
    stroke: "#006aff",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9971 7c0 0 0 4 .0030000000000001137 5 0 .5-.5 1-1 1C10.5001 13 10.293 13 10.293 13",
    stroke: "#006aff",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7h2v3H15z",
    fill: "#006aff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7h2v3H7z",
    fill: "#006aff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpersonate);
export default __webpack_public_path__ + "static/media/impersonate.42a66881.svg";
export { ForwardRef as ReactComponent };